import { render, staticRenderFns } from "./BasePage.vue?vue&type=template&id=2d0b7ddc&"
import script from "./BasePage.vue?vue&type=script&lang=ts&"
export * from "./BasePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports